
                import "css-modules://src_components_title_title"
                export default {"Main":"_552b2b","IsGrey02":"_b6a3e6","IsWhite":"_1b25fd","Subtitle":"_8116c3","Title":"_7fe5b8","Visible":"_ebc873"}
            